import { Link } from "react-router";
import { useScopeParams } from "@/hooks/useScopeParams";
import {
  parseVivoEntityHref,
  vivoEntityPath,
} from "@/utils/askVivoEntityLinks";
import { distinctKeys } from "@/utils/distinctKeys";
import type { QueryResultTable } from "./chat";

export default function SqlResultTable({ table }: { table: QueryResultTable }) {
  const { buildUrl, scope } = useScopeParams();

  if (!table.columns.length || !table.rows.length) return null;

  const rowKeys = distinctKeys(
    table.rows.map((row) => row.map((cell) => cell.text).join("␟")),
  );

  return (
    <div className="flex flex-col gap-1">
      <div className="overflow-x-auto">
        <table className="w-full border-collapse text-[12px]">
          <thead>
            <tr>
              {table.columns.map((column) => (
                <th
                  key={column}
                  className="border border-[#DDE3E6] bg-[#EFF1F2] px-2 py-1 text-left font-medium text-[#2B4752] whitespace-nowrap"
                >
                  {column}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {table.rows.map((row, rowIndex) => (
              <tr key={rowKeys[rowIndex]}>
                {row.map((cell, cellIndex) => {
                  const entity = parseVivoEntityHref(cell.ref);
                  const path = entity ? vivoEntityPath(entity, scope) : null;
                  return (
                    <td
                      key={table.columns[cellIndex]}
                      className="border border-[#DDE3E6] bg-white px-2 py-1 align-top"
                    >
                      {path ? (
                        <Link to={buildUrl(path)} className="vivo-entity-link">
                          {cell.text}
                        </Link>
                      ) : (
                        cell.text
                      )}
                    </td>
                  );
                })}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {table.truncated && (
        <span className="text-[11px] text-[#6F7F85]">
          Showing {table.rows.length} of {table.total_rows} rows.
        </span>
      )}
    </div>
  );
}
